import {setLanguage} from "@/redux/slices/commonSlices/settingsSlice";

import {useEffect, useRef, useState} from "react";

import {RootDesc} from "@ui/descriptions/RootDesc";
import {SmallDesc} from "@ui/descriptions/SmallDesc";
import {BorderArticle} from "@ui/general/BorderArticle";
import {Logo} from "@ui/general/Logo";
import {RootIcon} from "@ui/icons/RootIcon";
import {GB, RU} from "country-flag-icons/react/3x2";
import Cookies from "js-cookie";
import moment from "moment/min/moment-with-locales";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";

import styles from "./styles.module.scss";

export const RootHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {t, i18n} = useTranslation();

  const {isMobile, language} = useSelector((state) => state.common.settings);
  const [isOpen, setIsOpen] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const setRef = useRef(null);

  const test_server =
    window.location.host.includes("ava-test.cosmart") ||
    window.location.host.includes("ava-test.vivanti");
  const local_server = window.location.host.includes("localhost");

  const prod_eu = window.location.host.includes("ava.vivanti.eu");

  // TODO: убрать проверку языка когда быдет перевод этих страниц
  const navList = [
    {
      id: 0,
      name: t("header.nav.overview"),
      link: "overview",
      icon: null,
    },
    {
      id: 1,
      name: t("header.nav.features"),
      link: "features",
      icon: null,
    },
    {
      id: 2,
      name: t("header.nav.cases"),
      link: "cases",
      icon: null,
    },
    language !== "ru"
      ? {
          id: 3,
          name: t("header.nav.analytics"),
          link: "resources",
          icon: null,
        }
      : null,
    {
      id: 4,
      name: t("header.nav.effectiveness"),
      link: "roi",
      icon: null,
    },
    {
      id: 5,
      name: t("header.nav.suit"),
      link: "suit",
      icon: null,
    },
    {
      id: 6,
      name: t("header.nav.login"),
      link: "login",
      icon: "header_login_icon",
    },
  ];

  // TODO: заменить link в объектах когда будет РУ сервер
  const languages = [
    {
      id: 0,
      name: t("header.lang.eng_full"),
      shortName: "EN",
      value: "en",
      FlagIcon: GB,
      link: test_server
        ? "https://ava-test.vivanti.eu"
        : local_server
          ? "http://localhost:3000"
          : "https://ava.vivanti.eu",
    },
    !prod_eu
      ? {
          id: 1,
          name: t("header.lang.ru_full"),
          shortName: "RU",
          FlagIcon: RU,
          value: "ru",
          link: test_server
            ? "https://ava-test.cosmart.app"
            : local_server
              ? "http://localhost:3000"
              : "https://ava.vivanti.eu",
        }
      : null,
  ];

  const [selectedOption, setSelectedOption] = useState(languages[0].shortName);

  const toggleSelect = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option.shortName);
    setIsOpen(false);

    // TODO:удалить смену языка когда будет РУ сервер
    dispatch(setLanguage(option.value));
    Cookies.set("language", option.value);
    i18n.changeLanguage(option.value);
    moment.locale(option.value);
  };

  const handleClickOutside = (event) => {
    if (setRef.current && !setRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const handleClickBurger = () => {
    setMobileMenu(!mobileMenu);
  };

  const handleClickNavLink = (link) => {
    navigate(link.startsWith("/") ? link : `/${link}`);

    if (isMobile) {
      handleClickBurger();
    }
  };

  useEffect(() => {
    const currentLanguage = Cookies.get("language");
    const lang = {
      name: t("header.lang.en_full"),
      shortName: "EN",
      value: "en",
    };

    if (currentLanguage === "ru") {
      lang.name = t("header.lang.ru_full");
      lang.shortName = "RU";
      lang.value = "ru";
    }

    handleOptionClick(lang);

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.header_wrapper}>
      <div className={"container-big"}>
        <div className={styles.header_wrap}>
          <div className={styles.header_logo}>
            <Logo direction={"footer"} />
          </div>

          {!isMobile && (
            <nav className={styles.header_nav}>
              <ul>
                {navList &&
                  navList.length > 0 &&
                  navList.map(
                    (item) =>
                      item && (
                        <li
                          className={styles.header_nav_item}
                          key={item.id}
                          onClick={() => handleClickNavLink(item.link)}
                          style={
                            location.pathname.includes(item.link)
                              ? {
                                  pointerEvents: "none",
                                  background:
                                    "linear-gradient(135deg, #8692cb 0%, #b262c9 100%)",
                                }
                              : {pointerEvents: "all"}
                          }
                        >
                          {!item.icon && <i />}

                          <RootDesc>
                            <span>{item.name}</span>
                          </RootDesc>

                          {item.icon && (
                            <RootIcon
                              width={16}
                              height={16}
                              id={item.icon}
                            />
                          )}
                        </li>
                      ),
                  )}
              </ul>
            </nav>
          )}

          <div
            ref={setRef}
            className={styles.header_set}
          >
            <div
              className={styles.set_header}
              onClick={toggleSelect}
            >
              <RootDesc>
                <span>{selectedOption}</span>
              </RootDesc>

              <i
                style={
                  isOpen
                    ? {transform: "rotate(180deg)"}
                    : {transform: "rotate(0deg)"}
                }
              />
            </div>

            {isOpen && (
              <div className={styles.set_list}>
                <BorderArticle>
                  <div className={styles.set_body}>
                    <ul>
                      {languages.map((option) => {
                        if (!option) {
                          return null;
                        }

                        const {FlagIcon} = option;

                        return (
                          <li
                            style={
                              selectedOption.includes(option.shortName)
                                ? {
                                    pointerEvents: "none",
                                    background: "#fcf7fd",
                                    opacity: "0.5",
                                  }
                                : {}
                            }
                            className={
                              selectedOption.includes(option.shortName)
                                ? styles.activeOption
                                : ""
                            }
                            key={option.id}
                            onClick={() => handleOptionClick(option)}
                          >
                            <a rel={"noopener noreferrer"}>
                              <SmallDesc>
                                <span className={styles.langOption}>
                                  <FlagIcon className={styles.langFlag} />
                                  {option.name}
                                </span>
                              </SmallDesc>
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </BorderArticle>
              </div>
            )}
          </div>

          {isMobile && (
            <>
              <div
                onClick={handleClickBurger}
                className={styles.header_mobile_burger}
              >
                <RootIcon
                  width={28}
                  height={28}
                  id={mobileMenu ? "burger-close" : "burger-menu"}
                />
              </div>

              <nav
                className={`${styles.header_mobile_menu} ${
                  mobileMenu ? styles.header_mobile_menu_active : ""
                }`}
              >
                <ul>
                  {navList &&
                    navList.length > 0 &&
                    navList.map(
                      (item) =>
                        item && (
                          <li
                            key={item.id}
                            onClick={() => handleClickNavLink(item.link)}
                          >
                            <RootDesc>
                              <span>{item.name}</span>
                            </RootDesc>

                            {item.icon && (
                              <RootIcon
                                width={16}
                                height={16}
                                id={item.icon}
                              />
                            )}
                          </li>
                        ),
                    )}
                </ul>
              </nav>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
